import React from 'react';

import AccountsSettingsSimplifiIcon from 'assets/icons/settings-menu/accounts.settings.simplifi.inline.svg';
import BusinessSettingsIcon from 'assets/icons/settings-menu/business.inline.svg';
import CategoriesTagsSettingsSimplifiIcon from 'assets/icons/settings-menu/categories.tags.settings.simplifi.inline.svg';
import NotificationsSettingsSimplifiIcon from 'assets/icons/settings-menu/notifications.settings.simplifi.inline.svg';
import ProfileOutlineSimplfiIcon from 'assets/icons/settings-menu/profile.settings.simplifi.inline.svg';
import RecurringSettingsSimplifiIcon from 'assets/icons/settings-menu/recurring.settings.simplifi.inline.svg';
import RenamingRulesSettingsSimplifiIcon from 'assets/icons/settings-menu/renaming.rules.settings.simplifi.inline.svg';
import SecuritiesSettingsSimplifiIcon from 'assets/icons/settings-menu/securities.settings.simplifi.inline.svg';
import SharingSettingsIcon from 'assets/icons/settings-menu/sharing.inline.svg';
import TransctionIcon from 'assets/icons/settings-menu/transactions.settings.simplifi.inline.svg';
import TransferActivityIcon from 'assets/icons/settings-menu/transfer.inline.svg';

export const settingsTabs = Object.freeze({
  general: {
    name: 'General',
    icon: () => <ProfileOutlineSimplfiIcon width={20} height={20} />,
    allow: 'always',
  },
  accounts: {
    name: 'Accounts',
    icon: () => <AccountsSettingsSimplifiIcon width={20} height={20} />,
    allow: 'accountEnabled',
  },
  transactionsSettings: {
    name: 'Transactions',
    icon: () => <TransctionIcon width={20} height={20} />,
    allow: 'transactionsSettings',
  },
  businesses: {
    name: 'Businesses',
    icon: () => <BusinessSettingsIcon width={20} height={20} />,
    allow: 'businessEnabled',
  },
  categoriesTags: {
    name: 'Categories & tags',
    icon: () => <CategoriesTagsSettingsSimplifiIcon width={20} height={20} />,
    allow: 'categoriesTagsEnabled',
  },
  finances: {
    name: 'Finances',
    icon: () => <SharingSettingsIcon width={20} height={20} />,
    allow: 'financesEnabled',
  },
  notifications: {
    name: 'Notifications',
    icon: () => <NotificationsSettingsSimplifiIcon width={20} height={20} />,
    allow: 'notificationPreferences',
  },
  Recurring: {
    name: 'All recurring',
    icon: () => <RecurringSettingsSimplifiIcon width={20} height={20} />,
    allow: 'recurringManagement',
  },
  transactionRules: {
    name: 'Rules',
    icon: () => <RenamingRulesSettingsSimplifiIcon width={20} height={20} />,
    allow: 'transactionRules',
  },
  sharing: {
    name: 'Spaces & sharing',
    icon: () => <SharingSettingsIcon width={20} height={20} />,
    allow: 'sharingEnabled',
  },
  connectedAi: {
    name: 'Connected AI',
    icon: () => <SharingSettingsIcon width={20} height={20} />,
    allow: 'connectedAi',
  },
  transfers: {
    name: 'Transfer activity',
    icon: () => <TransferActivityIcon width={20} height={20} />,
    allow: 'a2aTransferEnabled',
  },
  securities: {
    name: 'Securities',
    icon: () => <SecuritiesSettingsSimplifiIcon width={20} height={20} />,
    allow: 'securitiesEnabled',
  },
});

export type SettingsTabs = keyof typeof settingsTabs;
